<template>
<transition name="fade">
	<section class="confirm" v-show="show">
		<section class="overlay" @click="close"></section>
		<section class="c-main">
			<i class="close" @click="close">X</i>
			<img :src="img">
			<!-- <p>{{title}}</p> -->
		</section>
	</section>
	</transition>
</template>

<style lang="less">
	@import '../css/confirm.less';
</style>

<script>
	export default {
		name: "confirm",
		props: {
			show: {
				type: Boolean,
				default: false
			},
			img: String,
			title: {
				type: String,
				default: '你暂未关注，长按二维码参与活动'
			}
		},
		methods: {
			close() {
				this.$emit('close');
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** confirm.vue?87f073c4
 **/